import './custom_assignments' // Defines ALL (window-)global custom vars/consts: ensure to correctly overwrite below
import { overwriteColors } from './colors_theben'
import { overwriteIcons } from './icons_theben'

overwriteColors()
overwriteIcons()
